const headers = {
  name: "Product category",
  navigate: {
    tabs: [
      {
        name: "Categories",
        path: "/app/products/categories",
      },
      {
        name: "Add",
        path: "",
      },
    ],
  },
};

export default headers;
